import firebase from "firebase";
import { getAppConfig } from "./config";

let app: firebase.app.App;
const config = getAppConfig();

export function initFirebase(): void {
    app = firebase.initializeApp(config.firebase);
}

export async function loginUser(authToken: string): Promise<void> {
    await app.auth().signInWithCustomToken(authToken);
}

export function onIdTokenChange(cb: (user: firebase.User) => void): void {
    app.auth().onIdTokenChanged(cb);
}

export async function getFirebaseUser(): Promise<firebase.User | null> {
    return await new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(
            function (user) {
                if (user) {
                    resolve(user);
                } else {
                    resolve(null);
                }
            },
            (err) => reject(err)
        );
    });
}

export async function logout() {
    await app.auth().signOut();
}
